import { Vue } from "vue-property-decorator";
import { SpaceReceiveMessageType } from "@/resources/constants/graphicClient/graphicClient";
import { Store } from "vuex";
import { i18n } from "@/resources/locales";

export default class SpaceHandler extends Vue {
  private static showModal = true;
  private static $store: Store<any>;
  static async handleMessage(
    message: string,
    value?: any | null,
    store?: Store<any>,
    vs?: any,
    loader?: any
  ): Promise<void> {
    switch (message) {
      case SpaceReceiveMessageType.SPACE_READY: {
        const rendererInfo = window["getGraphicClientRendererInfo"]();
        if (!rendererInfo || !rendererInfo.isWebGL2) {
          if (SpaceHandler.showModal) {
            SpaceHandler.showModal = false;
            vs?.notification({
              sticky: true,
              buttonClose: true,
              duration: "none",
              position: "top-center",
              color: "dark",
              text: `<div style="text-align: center">${i18n.t(
                "notifications.noWebGl2"
              )}. <a style="color:aquamarine;" href="https://get.webgl.org/webgl2/"
                    target="_blank">${i18n.t("notifications.testHere")}
            </a></div>`,
            });
          }
        }
        const user = store?.getters["UserStore/getSpaceUser"];
        const hasOnboarding = !localStorage.getItem("hasOnboarding")
          ? true
          : localStorage.getItem("hasOnboarding") === "true";
        if (user && (!user.superSpaceUser.user.isFirstTime || !hasOnboarding)) {
          const spaceId = store?.getters["SpaceStore/getSpace"].id;
          await store?.dispatch("SpaceStore/getOnlyUsersOnlineAction", {
            spaceId,
            callback: async (usersOnline) => {
              await store?.dispatch(
                "GraphicClientStore/spaceReadyAction",
                usersOnline
              );
            },
          });
        } else {
          setTimeout(async () => {
            const users = [user];
            if (user) {
              user.connectionStatus = "ONLINE";
              await store?.dispatch("SpaceStore/addUsersInSpaceAction", [
                {
                  ...user.superSpaceUser,
                  user: user.superSpaceUser.user,
                },
              ]);
              await store?.dispatch(
                "GraphicClientStore/spaceReadyAction",
                users
              );
              const hasOnboarding = !localStorage.getItem("hasOnboarding")
                ? true
                : localStorage.getItem("hasOnboarding") === "true";

              store?.dispatch(
                "SystemStore/setShowTutorialModalAction",
                hasOnboarding
              );
            }
          }, 1000);
        }
        break;
      }

      case SpaceReceiveMessageType.CREATE_WEBINAR: {
        const space = store?.getters["SpaceStore/getSpace"];
        const room = space.scenario.rooms.filter(
          (room) => room.id === value
        )[0];
        store?.dispatch("MeetingStore/setOpenWebinarUrlAction", {
          active: true,
          idRoom: value,
        });
        store?.dispatch("MeetingStore/setRoomIdWebinarUpdateAction", value);
        store?.dispatch("MeetingStore/setVideoUrlAction", room.videoUrl);
        break;
      }
      case SpaceReceiveMessageType.CLOSE_WEBINAR: {
        await store?.dispatch("SystemStore/setShowCloseWebinarModalAction", {
          close: true,
          id: value,
        });
        break;
      }
      case SpaceReceiveMessageType.CHANGE_WEBINAR_VIDEO: {
        const space = store?.getters["SpaceStore/getSpace"];
        const room = space.scenario.rooms.filter(
          (room) => room.id === value
        )[0];
        store?.dispatch("MeetingStore/setOpenWebinarUrlAction", {
          active: true,
          idRoom: value,
        });
        store?.dispatch("MeetingStore/setRoomIdWebinarUpdateAction", value);
        store?.dispatch("MeetingStore/setVideoUrlAction", room.videoUrl);
        break;
      }
      case SpaceReceiveMessageType.SPACE_GRAPHIC_CLIENT_LOADING_PROGRESS: {
        loader.setLoaderPercent(store, value > 90 ? 90 : value);
        if (value <= 30)
          loader.setLoaderText(
            store,
            i18n.t("loader.preparingSpace").toString()
          );
        if (value > 30 && value <= 60)
          loader.setLoaderText(
            store,
            i18n.t("loader.creatingSspace").toString()
          );
        else if (value > 60)
          loader.setLoaderText(
            store,
            i18n.t("loader.checkingSpace").toString()
          );
        break;
      }
      default: {
        console.error(
          `${message} is not defined in spaceMessageHandler method`
        );
        break;
      }
    }
  }
}
